/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAddImage = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M22 2H2v20h11v-2H4V4h16v9h2z" />
        <path d="m16 15-1.5-2-2.5 3-3-5-4 8h8v-3h3zm0-5a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm2 8v-3h2v3h3v2h-3v3h-2v-3h-3v-2z" />
      </g>
    </g>
  </Icon>
);
export { SvgAddImage as AddImage };
